import { Component, OnInit } from '@angular/core';
import { IModalConfig } from '../../../../shared/modules/bs-modal/interfaces/modal-config.interface';
import { ModalService } from '../../../../shared/modules/bs-modal/services/modal.service';
import { BenefitsPopUpComponent } from '../benefits-pop-up/benefits-pop-up.component';

const popup: IModalConfig = {
    content: BenefitsPopUpComponent,
    options: {
        initialState: {
            data: {
                showCloseButton: true,
                closeOnAction: true,
                benefitName: 'dis1',
                categoryName: 'cat'
            },
        } as Object
    },
    type: "Popup"
};

@Component({
    selector: 'app-benefits-plus',
    templateUrl: './benefits-plus.component.html',
    styleUrls: ['./benefits-plus.component.scss']
})
export class BenefitsPlusComponent implements OnInit {

    constructor(private modalSvc: ModalService) { }

    ngOnInit() {


        // this.modalSvc.openModal(popup).subscribe();

        // document.querySelector('modal-container').classList
        //     .add('pop-up-general', 'benefits-plus-popup');

    }



}

